import { Typography } from '@material-ui/core';
import { createContext, useContext, useState, ReactNode } from 'react';
import { ModalInfo } from '../themes/components/ModalInfo';
import { ModalProgress } from '../themes/components/ModalProgress';
import ReactLoading from 'react-loading';
import { Button } from '../themes/components/Button';

const ModalContext = createContext({} as PropsContextProvider);


type PropChildren = {
    children: ReactNode;
}

type PropsContextProvider = {
    setShowModalProgress: React.Dispatch<React.SetStateAction<boolean>>,
    setShowModalInfo: React.Dispatch<React.SetStateAction<boolean>>,
    setMensagem: React.Dispatch<React.SetStateAction<ReactNode>>,
    showModalProgress: boolean,
    showModalInfo: boolean,
    mensagem: any,
    mostrarModalProgress: (mensagem:string) => void,
    mostrarInfoOK: (mensagem:string, mensagem2?:string) => void,
}

export default function ModalProvider({ children }: PropChildren) {
    const [showModalInfo, setShowModalInfo] = useState<boolean>(false);
    const [showModalProgress, setShowModalProgress] = useState<boolean>(false);
    const [mensagem, setMensagem] = useState<ReactNode>(<></>);

    function mostrarModalProgress(mensagem: string) {
        setMensagem(
            <div className='mensagem-info-modal-loading'>
                <Typography>{mensagem}</Typography>
                <ReactLoading type={"bars"} color={"#0252a8"} height={30} width={50} />
            </div>
        )
        setShowModalInfo(false);
        setShowModalProgress(true);
    }

    function mostrarInfoOK(mensagem1: string, mensagem2?:string) {
        setMensagem(
            <div className='mensagem-info-modal-loading'>
                <Typography>{mensagem1}</Typography>
                {mensagem2 !== undefined ? <Typography>{mensagem2}</Typography> : <></>}
                <Button onClick={() => setShowModalInfo(false) } classBtn={"btn-notifications color-default"}>OK</Button>
            </div>
        )
        setShowModalProgress(false);
        setShowModalInfo(true);
    }

    return (
        <ModalContext.Provider
            value={{
                showModalInfo,
                showModalProgress,
                mensagem,
                setShowModalProgress,
                setShowModalInfo,
                setMensagem,
                mostrarModalProgress,
                mostrarInfoOK
            }}>
            {children}
            <ModalInfo setShowModalInfo={setShowModalInfo} showModalInfo={showModalInfo}>{mensagem}</ModalInfo>
            <ModalProgress setShowModalProgress={setShowModalProgress} showModalProgress={showModalProgress}>{mensagem}</ModalProgress>
        </ModalContext.Provider>
    )
}

//A intenção de usar o hook para o contexto é facilitar a importação nos componentes,
//Somente o que estiver nesse hook poderá ser importado via hook, obviamente!
export function useModals() {
    const context = useContext(ModalContext);
    if (!context) throw new Error("useModal deve ser usado dentro de um ModalProvider");
    const {
        showModalInfo,
        showModalProgress,
        mensagem,
        setShowModalProgress,
        setShowModalInfo,
        setMensagem,
        mostrarModalProgress,
        mostrarInfoOK } = context;
    return ({
        showModalInfo,
        showModalProgress,
        mensagem,
        setShowModalProgress,
        setShowModalInfo,
        setMensagem,
        mostrarModalProgress,
        mostrarInfoOK
    });
}